const initialState = {
    data: [],
  };
  
const planowaneZuzycieReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PLANOWANE_ZUZYCIE':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default planowaneZuzycieReducer;